import React from 'react';
import { observer } from 'mobx-react';
import { Preloader as KsnmPreloader } from 'ksnm-common-ui/lib/Preloader';
import type { ReactElement } from 'react';

import { preloaderStore } from '@stores/preloaderStore';

const preloader = function Preloader(): ReactElement | null {
  return preloaderStore.showPreloader ? <KsnmPreloader message={preloaderStore.preloaderMessage} /> : null;
};

export const Preloader = observer(preloader);
